/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import PropTypes from "prop-types";
import React from "react";
import { AdService } from "../ad-service";
import { WidgetComponent } from "../Widget";

export const AdComponent = component => {
  const { layout, layoutLabel, config } = component;
  const { targetingId } = config;

  return (
    <div className="app-ad app-ad--story-horizontal">
      <AdService adtype={layout} layoutName={layoutLabel} adTargetingId={targetingId} shouldRefreshOnce />
    </div>
  );
};

export const WidgetComp = ({ widgetCode }) => {
  let widget;
  try {
    if (window) {
      widget = window.atob(widgetCode);
    } else {
      const buf = Buffer.from(widgetCode, "base64");
      widget = buf.toString("utf-8");
    }
  } catch (e) {
    widget = "";
  }
  return (
    <div className="app-ad app-ad--story-horizontal">
      <WidgetComponent widgetValue={decodeURIComponent(widget)} />
    </div>
  );
};

WidgetComp.propTypes = {
  widgetCode: PropTypes.string
};
